var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_403_3889"
  }, /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_403_3889"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_403_3889)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EFF4F1",
    height: 3.22,
    width: 3.22,
    x: 2.3,
    y: 20.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.45,2.28c0,-1.19 0.96,-2.15 2.14,-2.15l15.04,0c1.19,0 2.15,0.96 2.15,2.15l0,19.32c0,1.19 -0.96,2.15 -2.15,2.15l-17.18,0l0,-21.47z",
    fill: "#EFF4F1",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.15,10.87c0,-0.6 0.48,-1.08 1.07,-1.08l3.22,0l0,11.81c0,1.19 -0.96,2.15 -2.15,2.15c-1.18,0 -2.14,-0.96 -2.14,-2.15l0,-10.73z",
    fill: "#8BA293",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFA692",
    height: 6.75,
    rx: 1.27,
    width: 14.34,
    x: 7.17,
    y: 2.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.67,12.78l12.88,0",
    stroke: "#8BA293",
    strokeLinecap: "round",
    strokeWidth: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.67,16.23l12.88,0",
    stroke: "#8BA293",
    strokeLinecap: "round",
    strokeWidth: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.67,19.68l12.88,0",
    stroke: "#8BA293",
    strokeLinecap: "round",
    strokeWidth: 1.78
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.9e5d4dac795f57580cb089873f4fabc4.svg";
export { ForwardRef as ReactComponent };